<template>
  <div class="wrapper">
    <div class="slogan"><h3>必扑驱蚊设备管理系统</h3></div>
    <div class="loginDiv">
      <div class="loginTitle"><b>厂商登录</b></div>
 <!--     <div class="method">
        <span :class="index==loginMethodIndex?'on':''" v-for="(item,index) in loginMethod" @click="changeTab(index)">{{item}}</span>
      </div> -->
      <el-form :model="user" ref="userForm" class="loginForm">
        <template v-if="loginMethodIndex==0">
          <el-form-item prop="username">
            <el-input size="large" placeholder="请输入用户名" style="margin: 10px 0" prefix-icon="el-icon-user" v-model="user.username"></el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input size="large" placeholder="请输入密码" style="margin: 10px 0" prefix-icon="el-icon-lock" show-password v-model="user.password"></el-input>
          </el-form-item>
        </template>
        <template v-if="loginMethodIndex==1">
        <el-form-item prop="username">
          <el-input size="large" placeholder="请输入用手机号" style="margin: 10px 0" prefix-icon="el-icon-mobile" v-model="user.phone"></el-input>
        </el-form-item>
        <el-form-item prop="username" class="verifyDiv">
          <el-input size="large" placeholder="请输入验证码" style="margin: 10px 0" prefix-icon="el-icon-connection" v-model="user.verify"></el-input>
          <span class="sendBn" v-if="haveSend">{{second}}&nbsp;秒</span>
          <span class="sendBn" @click="sendCode" v-else>发送验证码</span>
        </el-form-item>
        </template>
        <el-form-item class="loginBn">
          <el-button type="primary" style="width:100%;"  autocomplete="off" @click="login">登录</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div id="bah" style="
    height: 100%;
    width: 100%;">
      <span style="
      position: absolute;
      left: 50%;
      bottom: 20px;
      transform: translateX(-50%);">
    <a href="https://beian.miit.gov.cn">必扑智能科技（青岛）有限公司 , 鲁ICP备2025145389号-2</a></span>
  </div>
  </div>
</template>

<script>
import {login,codeLogin,getVerify} from '@/api/api'
import {testLength,testNull} from '@/api/utils'
export default {
  name: "Login",
  data() {
    return {
      user: {},
      // loginMethod:['账号密码登录','短信验证码登录'],
      loginMethod:['账号密码登录'],
      loginMethodIndex:0,
      second:60,
      haveSend:false
    }
  },
  destroyed() {
      // 销毁enter事件
      this.enterKeyupDestroyed();
  },
  mounted(){
    this.enterKeyup()
  },
  methods: {
    enterKey(event) {
        const componentName = this.$options.name;
        if (componentName == "Login") {
            const code = event.keyCode ? event.keyCode: event.which ? event.which : event.charCode;
            if (code == 13) {
                this.login();
            }
        }
    },
    enterKeyupDestroyed() {
        document.removeEventListener("keyup", this.enterKey);
    },
    enterKeyup() {
        document.addEventListener("keyup", this.enterKey);
    },
    changeTab(index){
      this.loginMethodIndex=index
    },
    login() {
        let test=true
        const {username,password,phone,verify} = this.user
        if(this.loginMethodIndex==0){
          test=testNull(this,username,'用户名')
          if(!test){return false}
          test=testNull(this,password,'密码')
          if(!test){return false}
          test=testLength(this,username,3,16,'用户名')
          if(!test){return false}
          test=testLength(this,password,6,18,'密码')
          if(!test){return false}
          var data=JSON.stringify({
            usrName:username,
            passWord:password
          })
          login(data).then(res=>{
            if(res.data.data!=''){
              let userInfo=res.data.data[0]
              let factoryName=res.data.data[0].factoryName
              this.$store.commit('saveUserInfo',userInfo)
              localStorage.setItem('loginState','Y')
              localStorage.setItem('factoryName',factoryName)
              this.$router.push('/main')
            }else{
              this.$message({
                 message: '登录失败',
                 type: 'warning'
              });
            }
          })
        }
        if(this.loginMethodIndex==1){
          test=testNull(this,phone,'手机号')
          if(!test){return false}
          test=testNull(this,verify,'验证码')
          if(!test){return false}
          test=testLength(this,phone,-1,11,'手机号')
          if(!test){return false}
          test=testLength(this,verify,-1,6,'验证码')
          if(!test){return false}
          var data=JSON.stringify({
            phone:phone,
            code:verify
          })
          codeLogin(data).then(res=>{
            if(res.data.state==200&&res.data.code==''){
              let userInfo=res.data.data[0]
              let factoryName=res.data.data[0].factoryName
              this.$store.commit('saveUserInfo',userInfo)
              localStorage.setItem('loginState','Y')
              localStorage.setItem('factoryName',factoryName)
              this.$router.push('/main')
            }else{
              this.$message({
                 message:res.data.code,
                 type: 'warning'
              });
            }
          })
        }
        // if(user.username=='admin'&&user.password=='123456'){
        //    localStorage.clear()
        //    localStorage.setItem('manager','M')
        //    this.$router.push('/')
        // }else{
        //   this.$message({
        //      message: '登录失败',
        //      type: 'warning'
        //   });
        // }
    },
    sendCode(){
      let phone=this.user.phone
      if(phone==''||phone==undefined){
        this.$message({
            message: '请输入手机号',
            type: 'warning'
          });
        return false
      }
      var data=JSON.stringify({
        phone:this.user.phone,
      })
      getVerify(data).then(res=>{})   //发送手机验证码
      this.haveSend=true
      let count=60
      var that=this
      let interval=setInterval(function(){
        if(count>1){
          count-=1
          that.second=count
        }else{
          clearInterval(interval)
          that.haveSend=false
        }
      },1000)
    }
  }
}
</script>

<style>
  .wrapper {
    height: 100vh;
   background-image:url(../assets/login_bg.jpg);background-position: top center ;background-repeat:no-repeat;background-size:100% 100%;;
    overflow: hidden;
  }
  .loginDiv {margin: 0px auto; background-color: #fff; width: 350px; height: 350px; padding: 20px 40px; border-radius: 10px;box-shadow: #f4f4f4 0px 0px 10px;}
  .loginTitle { font-size: 20px;margin-top:10px;height:50px; text-align: center;}
  .loginTitle b {font-weight:500;}
  .method {height:50px;}
  .method span {color:#999;height:50px;line-height: 50px;padding-bottom:10px;margin-right:30px;}
  .method span.on {color:#596573;border-bottom: #596573 3px solid;}
  .loginForm {margin-top:10px;}
  .loginBn {margin: 10px 0; text-align: right}
  .loginBn .el-button {background:#596573;border:0;}
  .verifyDiv {position: relative;}
  .sendBn  {color:#596573;position: absolute;top:10px;right:15px;}
  .slogan {font-size:28px;text-align: center;margin-top:10%;}
  .slogan h3 {font-weight:500;}
</style>



// WEBPACK FOOTER //
// src/views/Login.vue